// This utility function generates typography styles based on the provided font size and weight.

import { SPACERS } from '~/theme'

type TypographySize = 'caption' | 'small' | 'medium' | 'large' | 'extraLarge' | 'heading'

interface TypographyConfig {
  fontSize: string
  fontWeight: 'bold' | 'bolder' | 'normal' | 'lighter' | 'inherit' | number
  lineHeight: string
}

const createTypography = (
  size: TypographySize,
  fontWeight?: 'bold' | 'bolder' | 'normal' | 'lighter' | 'inherit' | number
): TypographyConfig => {
  const sizeConfigs: Record<TypographySize, Omit<TypographyConfig, 'fontWeight'>> = {
    caption: {
      fontSize: SPACERS.sm,
      lineHeight: SPACERS.md,
    },
    small: {
      fontSize: SPACERS.sm,
      lineHeight: SPACERS.lg,
    },
    medium: {
      fontSize: SPACERS.md,
      lineHeight: SPACERS.xl,
    },
    large: {
      fontSize: SPACERS.lg,
      lineHeight: SPACERS.xxl,
    },
    extraLarge: {
      fontSize: SPACERS.xl,
      lineHeight: SPACERS.xxl,
    },
    heading: {
      fontSize: SPACERS.xxl,
      lineHeight: SPACERS.xxxl,
    },
  }

  return {
    ...sizeConfigs[size],
    fontWeight: fontWeight || 'normal',
  }
}

export default createTypography
